export default __webpack_public_path__ + "static/media/gore.6096787e.jpg";